module.exports = __webpack_public_path__ + "static/media/interactive-text.abe9597b.svg";